export default "__VITE_ASSET__BKNvt7H1__"